import { useGetDormakabaAccessPoints } from '@/api/keyless/dormakaba/get-dormakaba-access-points'

import { useGetDormakabaConnection } from './get-dormakaba-connection'

type UseIsDormakabaBuildingConnectedOptions = {
  // Also require the live access-points probe to pass — catches "configured but credentials
  // broken", not just "never configured". Opt-in (new-design tab only) until Backend confirms
  // the endpoint's behaviour for legacy SOAP buildings.
  withLiveProbe?: boolean
}

// Shared by Places → Integrations (config-only) and the resident Keyless Access tab.
export const useIsDormakabaBuildingConnected = (
  buildingId: number,
  { withLiveProbe = false }: UseIsDormakabaBuildingConnectedOptions = {},
) => {
  const { isLoading: isLoadingConfig, isSuccess: isConfigSuccess } = useGetDormakabaConnection({
    buildingId,
  })
  const {
    isError: isAccessPointsError,
    isLoading: isLoadingAccessPoints,
    isSuccess: isAccessPointsSuccess,
  } = useGetDormakabaAccessPoints({ buildingId }, withLiveProbe)

  return {
    isBuildingConnected: isConfigSuccess && (!withLiveProbe || isAccessPointsSuccess),
    // Configured, but the live probe failed/timed out — "try again later", not "not configured".
    isLiveProbeUnavailable: withLiveProbe && isConfigSuccess && isAccessPointsError,
    isLoading: isLoadingConfig || (withLiveProbe && isLoadingAccessPoints),
  }
}
